module.exports = __webpack_public_path__ + "static/media/21_strawberry.cb201af8.JPG";